import request from '@/utils/http';
import store from '@/store/index';
import { PFX } from '../../constant/constant.js';
const tenantCode = store.getters.currentTenant.tenantCode;

const calculateRouter = {
    // 搜索列表
    search (params) {
        params.tenantCode = tenantCode;
        return request({
            url: `${PFX}/contract/contractPaymentTermCofigs`,
            method: 'post',
            data: params
        });
    },
    // 删除
    del(params) {
        return request({
            url: `${PFX}/contract/contractPaymentTermCofig/delList`,
            method: 'post',
            data: params
        });
    },
    // 保存
    save(params) {
        if (Array.isArray(params)) {
            params.forEach(item => {
                if (item.tenantCode === undefined) {
                    item.tenantCode = tenantCode;
                }
            });
        }
        return request({
            url: `${PFX}/contract/contractPaymentTermCofig`,
            method: 'post',
            data: params
        });
    }
};
export default calculateRouter;
